(() => {
  const emit = (event, detail = {}) => {
    if (window.AVAnalytics?.consentAllowed?.() !== true) return false;
    window.dispatchEvent(new CustomEvent('av:analytics', { detail: { event, ...detail } }));
    return true;
  };

  document.querySelectorAll('[data-journal-series]').forEach((series) => {
    const buttons = [...series.querySelectorAll('[data-journal-filter]')];
    const cards = [...series.querySelectorAll('[data-journal-grid] [data-journal-card]')];
    const count = series.querySelector('[data-journal-result-count]');

    const update = (filter) => {
      let visible = 0;
      cards.forEach((card) => {
        const show = filter === 'todos' || card.dataset.journalCategory === filter;
        card.classList.toggle('is-filtered-out', !show);
        card.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) visible += 1;
      });
      buttons.forEach((button) => {
        const active = button.dataset.journalFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (count) count.textContent = `${visible} ${visible === 1 ? series.dataset.resultSingular : series.dataset.resultPlural}`;
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      const filter = button.dataset.journalFilter;
      update(filter);
      emit('journal_filter_select', { series: 'comida-de-verdade', filter });
    }));
    update('todos');
  });

  document.querySelectorAll('[data-journal-toc-link]').forEach((link) => {
    link.addEventListener('click', () => emit('journal_toc_select', {
      article_handle: document.querySelector('[data-journal-article]')?.dataset.journalArticle || '',
      destination: link.getAttribute('href') || ''
    }));
  });
})();
